import getAttributesImport from '../../store/attributes'
import { LOCALE_CHANGED } from '../../constants'
import { selectors as backendSelectors } from '../Backend'
import { selectors as settingsSelectors } from '../Settings'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return { url: attributes.service.motd }
}

export function getLayout(state) {
    return settingsSelectors.getLayout(state)
}

export function getLocale(state) {
    return backendSelectors.getLocale(state)
}

export const constants = {
    LOCALE_CHANGED,
}

export { launcherOpenUrl } from '../../launcherBackend/launcher-command'



// WEBPACK FOOTER //
// ./src/features/Toaster/imports.js